// For any future developers, please separate your concerns
// MailServices idb is used for Mail-related things. Keep it that way!

// import { openDB, deleteDB, wrap, unwrap } from 'idb';
import { openDB } from 'idb';
import idb from '@/idb';

// Utils
import DataUtil from '@/utils/DataUtil';

const STORE_NAME = 'stored_actions';
const STORE_INDICES = {
    action_type: 'action_type',
};

async function standupDatabase() {
    return openDB( 'Mail_Services', 1, {
        // eslint-disable-next-line no-unused-vars
        upgrade( database, oldVersion, newVersion, transaction ) {
            // console.log( 'This version of the database has never been opened before. Specify the schema for the database here.' );
            const store = database.createObjectStore( STORE_NAME, {
                // The 'timestamp' property of the object will be the key
                keyPath: 'timestamp',
                // If it isn't explicitly set, create a value by auto incrementing.
                autoIncrement: true,
            } );
            // Create an index on each stored actions' 'type'
            store.createIndex( STORE_INDICES.action_type, 'type' );
        },
        blocked() {
            console.log( 'blocked' );
        },
        blocking() {
            console.log( 'blocking' );
        },
    } );
}

/**
 * @private
 * Store an action to be replayed later
 * @params { String } actionType - a fully addressable namespaced vuex action name
 * @params { Object } payload - the payload to be supplied to the given actionType
 */
async function storeAction( actionType, payload ) {
    const db = await standupDatabase();
    await db.add( STORE_NAME, idb.formatActionToBeStored( actionType, payload ) );
}
/**
 * @public
 * Remove an action by its timestamp
 * @param { import('@/typedefs/indexedDatabaseStoredAction').indexedDatabaseStoredAction } action
 */
async function removeAction( action ) {
    const db = await standupDatabase();
    await db.delete( STORE_NAME, action.timestamp );
}

/**
 * @public
 * Return all stored actions in the database
 * @returns { import('@/typedefs/indexedDatabaseStoredAction').indexedDatabaseStoredAction[] }
 */
async function getAllActions() {
    const db = await standupDatabase();
    return db.getAllFromIndex( STORE_NAME, STORE_INDICES.action_type );
}

/**
 * @public
 * Store an action to be replayed later if it doesn't already exist in the database
 * @params { String } actionType - a fully addressable namespaced vuex action name
 * @params { Object } payload - the payload to be supplied to the given actionType
 */
async function storeNewAction( actionType, payload ) {
    const existingStoredActions = await getAllActions();
    // changes() will return null if there are no differences between a reference and another value
    // If the resulting mapped array includes null, we can be sure that the { actionType, payload } already exists in the database.
    // Remove the timestamp in order to have a valid comparison
    const actionExists = existingStoredActions
        .map( ( existingAction ) => DataUtil.changes(
            {
                type: existingAction.type,
                payload: existingAction.payload,
            },
            {
                type: actionType,
                payload,
            },
        ) )
        .includes( null );
    if ( !actionExists ) {
        await storeAction( actionType, payload );
    }
}

export default {
    standupDatabase,
    removeAction,
    getAllActions,
    storeNewAction,
};
